import { DomService } from '../dom';
import { UserType } from '../../../types/user-type';
import { Country } from '../../../types/country';

export const RCM_USER_TYPE_KEY = 'RcmUserType';
export const RCM_SELECTED_USER_TYPE_KEY = 'RcmSelectedUserType';
export const RCM_COUNTRY_CONSENT_KEY = 'RcmCountryConsent';
export const RCM_USER_TYPE_RETAIL = 'retail';
export const RCM_USER_TYPE_INSTI = 'institutional';
export const RCM_USER_TYPE_CEE = 'cee';
export const RCM_CHANNEL_RETAIL = 'Internet-KAG';
export const RCM_CHANNEL_INSTI = 'Internet-KAG%20Institutionell';
export const RCM_NO_USER_TYPE_COUNTRIES = ['li', 'bg', 'pl', 'ro'];

export const AppService = {
  getUrlSearchParams(): URLSearchParams {
    return new URL(window.location.href).searchParams;
  },

  getUserType(): UserType | null {
    const userTypeFromConfig = DomService.getGlobalConfig().userType as UserType;

    return (
      userTypeFromConfig ||
      (window.localStorage.getItem(RCM_USER_TYPE_KEY) as UserType) ||
      (window.sessionStorage.getItem(RCM_USER_TYPE_KEY) as UserType) ||
      null
    );
  },

  isUserTypeStored(): boolean {
    return !!window.localStorage.getItem(RCM_USER_TYPE_KEY) || !!window.sessionStorage.getItem(RCM_USER_TYPE_KEY);
  },

  isCurrentUserTypeStored(userType: UserType): boolean {
    return (
      window.localStorage.getItem(RCM_USER_TYPE_KEY) === userType?.toString() ||
      window.sessionStorage.getItem(RCM_USER_TYPE_KEY) === userType?.toString()
    );
  },

  setUserType(userType: string, persist: boolean = false): void {
    if (persist) {
      window.sessionStorage.removeItem(RCM_USER_TYPE_KEY);
      window.localStorage.setItem(RCM_USER_TYPE_KEY, userType);
    } else {
      window.localStorage.removeItem(RCM_USER_TYPE_KEY);
      window.sessionStorage.setItem(RCM_USER_TYPE_KEY, userType);
    }
  },

  setUserCountryConsent(userType: UserType, country: Country, persist: boolean = false): void {
    this.setUserType(userType, persist);
    if (persist) {
      window.sessionStorage.removeItem(RCM_COUNTRY_CONSENT_KEY);
      window.localStorage.setItem(RCM_COUNTRY_CONSENT_KEY, country);
    } else {
      window.localStorage.removeItem(RCM_COUNTRY_CONSENT_KEY);
      window.sessionStorage.setItem(RCM_COUNTRY_CONSENT_KEY, country);
    }
  },

  isCurrentUserCountryConsentStored(userType: UserType, country: Country): boolean {
    const isUserTypeStored = this.isCurrentUserTypeStored(userType);
    return (
      isUserTypeStored &&
      (window.localStorage.getItem(RCM_COUNTRY_CONSENT_KEY) === country?.toString() ||
        window.sessionStorage.getItem(RCM_COUNTRY_CONSENT_KEY) === country?.toString())
    );
  },

  getChannelByCurrentUserType(): string {
    return this.getUserType() === RCM_USER_TYPE_RETAIL ? RCM_CHANNEL_RETAIL : RCM_CHANNEL_INSTI;
  },
};
